import $ from 'jquery';

module.exports = function () {
    const socialLink = $('.social-media-item');
    const howMany = socialLink.length;

    if (howMany > 1) {
        socialLink.addClass('social-media-item__bottom-border');
    }
};
